import { AccessObjectTypeEnum } from '@/Services/api/methods';

/**
 * A crutch due to the work of the selector.
 */
export const AccessObjectNumberMap: Record<AccessObjectTypeEnum, number> = {
    [AccessObjectTypeEnum.STORE_GROUP]: 1,
    [AccessObjectTypeEnum.STORE]: 2,
};

/**
 * Mapping of AccessObjectTypeEnum values to normalized display strings
 */
export const AccessObjectTypeLabels: Record<AccessObjectTypeEnum, string> = {
    [AccessObjectTypeEnum.STORE_GROUP]: 'Store Group',
    [AccessObjectTypeEnum.STORE]: 'Store',
};

/**
 * Returns normalized string for AccessObjectTypeEnum value
 */
export const getAccessObjectTypeLabel = (type: AccessObjectTypeEnum | undefined | null): string => {
    if (!type) {
        return '';
    }
    return AccessObjectTypeLabels[type] || '';
};
